
import react, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useParams, useLocation, Link, Link as RouterLink} from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Button, Typography, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import * as leadActions from "../../actions/leadActions";


const FiDetils = ({ props, allFiSaveHistory, leadId,pageTitle, setSectionName,AgreementNo }) => {
  const { id } = useParams();
  const location = useLocation();
  const { actions, addEditNoteHistoryPage, NoteHistoryPageData, relationShipData, identifiersData } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  const [getAllNoteHistoryPageData, setAllNoteHistoryPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [open, setOpen] = useState(false);
  const [isMappingStatus, setIsMappingStatus] = useState(false);

  const [fIAttachments, setFIAttachments] = useState([]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };


  const filteredItems = allFiSaveHistory.filter(item => {
    const formattedID = item.formatetdID?.toLowerCase() || '';

    return (
      formattedID.includes(searchQuery.toLowerCase())
    );
  }
  );


  const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
  const endIndex = startIndex + config.ITEMS_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

  const onRowClickAction = (itemObj, btnAction) => {
    setViewModalInfo(itemObj);
    setOpen(true);
    setIsMappingStatus(false);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const [viewDetailsModalInfo, setViewDetailsModalInfo] = useState([]);
  const [jsonViewDetailsModalInfo, setJsonViewDetailsModalInfo] = useState(null);
 
  const btnViewDetailsHandler = (apiResponse,attachments= []) => {    // buttonFun 

        const parsedDetails =  apiResponse !== '' ? JSON.parse(apiResponse) : [];
        setViewDetailsModalInfo(parsedDetails);
         setJsonViewDetailsModalInfo(apiResponse);
        setViewDetailsOpen(true); 

        setFIAttachments(attachments);
    };

    const handleViewDetailsClose = () => {
        setViewDetailsOpen(false);
    };

     const RenderObject = ({ data }) => {
  if (!data) return null;

  // If data is an array → render list
  if (Array.isArray(data)) {
    return (

      <>
      <div className="p-3 space-y-3">
        {data.length === 0 ? (
          <div className="ml-4 italic text-gray-500">No Data</div>
        ) : (
          data.map((item, index) => (
            <div key={index} className="border-b pb-2">
              <strong className="block text-gray-700">
                {item.questionText} : 
              </strong>
              <span className="text-gray-900">
               &nbsp; {Array.isArray(item.userAnswers)
                  ? item.userAnswers.join(", ")
                  : item.userAnswers}
              </span>
              {/* Show otherText if exists */}
              {item.otherText && (
                <div className="text-sm text-blue-600 mt-1">
                  <em>Address : </em> {item.otherText}
                </div>
              )}
            </div>
          ))
        )}
      </div>  
  </>
    );
  }

  // If data is an object → recursively render its values
  if (typeof data === "object") {
    return (
      <div className="space-y-2 ml-4">
        {Object.entries(data).map(([key, value], index) => (
          <div key={index}>
            <span className="font-semibold">{key}: </span>
            <RenderObject data={value} />
          </div>
        ))}
      </div>
    );
  }

  // For primitive values
  return <span>{String(data)}</span>;
};

  return (
    <>
      <div id="main-wrap" className='mt-4'>
        <div className='row justify-content-between'>
          <div className='col-md-12'>
            <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
              {pageTitle}
            </Typography>
          </div>

          <div className='col-md-4 pe-0 ps-lg-5 hide'>
            <div className="form-group">
              <label htmlFor="search">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  id="search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </label>
            </div>
          </div>
        </div>
        <div className="table-wrap">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>{setSectionName === 'vehicle_inspection_form' ? "Inspection Done On" : "Created Date"}</th>
                <th>{setSectionName === 'vehicle_inspection_form' ? "Inspection Done Date" : "Created By"}</th>
                <th>Location</th>
                <th>Lat. / Long.</th>
                
                <th>Stage</th> 

                {(setSectionName === 'vehicle_inspection_form' || setSectionName === 're_fi_checklist') && (
                  <>
                   <th>&nbsp;</th> 
                  </>
                ) }             
              </tr>
            </thead>
            <tbody>
              {paginatedItems.map((item, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>{item.created_date}</td>
                  <td>{item.createdByName}</td>
                  <td>{item.address}</td>
                  <td>{item.latitude} / {item.longitude}</td>
                  <td>{item.action.toUpperCase()}</td>

                   { (setSectionName === 'vehicle_inspection_form' || setSectionName === 're_fi_checklist') && (
                  <>
                   <td>
                    
                    { item?.saved_questions_data !== '' ? (
                      <>
                        <button
                          type="button"
                          onClick={() => btnViewDetailsHandler(item.saved_questions_data ,item?.attachments)}
                          style={{ color: "green", background: "none", border: "none", cursor: "pointer" , width: "auto !important",
                              float: "right" }}
                          aria-label="View details"
                      >
                          <i className="nav-icon bi bi-eye">&nbsp;</i>
                      </button>
                      </>

                    ) : (
                      <>
                        { item?.saved_credit_questions_data !== '' ? (
                      <>
                        <button
                          type="button"
                          onClick={() => btnViewDetailsHandler(item.saved_credit_questions_data ,item?.attachments)}
                          style={{ color: "green", background: "none", border: "none", cursor: "pointer" , width: "auto !important",
                              float: "right" }}
                          aria-label="View details"
                      >
                          <i className="nav-icon bi bi-eye">&nbsp;</i>
                      </button>
                      </>

                    ) : (
                      <>
                        &nbsp;
                      </>
                    )}
                      </>
                    )}                    
                   </td>
                  </>
                ) }  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <nav className='mb-1'>
          <ul className="pagination pagination-md justify-content-end">
            {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
              <li className="page-item">
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  disabled={currentPage === page}
                  className="page-link"
                >
                  {page}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          >
          <div className='modal-custom rounded'>
              <div className='modal-head'>
              <h4 id="modal-title">Note Info</h4>
              </div>

              <div className='modal-body'>
              <div className='row mb-2 pb-1'>
                  <div className='col-4'><b>Note :</b></div>
                  <div className='col-7 ps-0'>{viewModalInfo.comment}</div>
              </div>
              </div>
          </div>
      </Modal>


       <Modal
          open={viewDetailsOpen}
          onClose={handleViewDetailsClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
      >
          <div className='modal-custom rounded'>
              <div className='modal-head'>
                  <h4 id="modal-title">Details</h4>
              </div>
              <div className='modal-body' style={{ maxHeight: "400px", overflowY: "auto", padding: "1rem"}}>
                  <div className='row mb-2 pb-1'>
                       <div className="col-12 ps-0">  
                          {viewDetailsModalInfo ? (
                              (() => {
                              const { result } = viewDetailsModalInfo;
                              return (
                                  <div>
                                      <RenderObject data={viewDetailsModalInfo} />                                                    
                                  </div>
                              );
                              })()
                          ) : (
                              <p>No details available</p>
                          )}
                          <hr/>
                          <div style={{padding: "10px"}}>
                           {fIAttachments?.length > 0 && (
                              fIAttachments.map((itemFile, index) => (
                                <>
                                  <div key={index}>
                                       Comment : {itemFile.file_comment}  <br />
                                      <a href={itemFile.file_url} target="_blank" rel="noopener noreferrer"> {itemFile.upload_file} </a>
                                  </div>
                                  <hr/>
                                  </>
                              ))
                            ) } 
                             &nbsp;
                          </div>
                         
                          </div>
                  </div>
              </div>
          </div>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  return {
    addEditNoteHistoryPage: state.addEditNoteHistoryPage,
    NoteHistoryPageData: state.NoteHistoryPageData,
    relationShipData: state.relationShipData,
    identifiersData: state.identifiersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FiDetils);
